__turbopack_context__.v({
  "changes-ring": "index-module-scss-module__rS8M8a__changes-ring",
  "changes-ring-wrapper": "index-module-scss-module__rS8M8a__changes-ring-wrapper",
  "editor-wrapper": "index-module-scss-module__rS8M8a__editor-wrapper",
  "template-btn": "index-module-scss-module__rS8M8a__template-btn",
  "template-btn-disabled": "index-module-scss-module__rS8M8a__template-btn-disabled",
  "template-btn-selected": "index-module-scss-module__rS8M8a__template-btn-selected",
  "template-group": "index-module-scss-module__rS8M8a__template-group",
});
